import { render, staticRenderFns } from "./UserInputButton.vue?vue&type=template&id=e81f426a"
import script from "./UserInputButton.vue?vue&type=script&lang=js"
export * from "./UserInputButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports